import { render, staticRenderFns } from "./JEditableTable.vue?vue&type=template&id=46635c48&scoped=true"
import script from "./JEditableTable.vue?vue&type=script&lang=js"
export * from "./JEditableTable.vue?vue&type=script&lang=js"
import style0 from "./JEditableTable.vue?vue&type=style&index=0&id=46635c48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46635c48",
  null
  
)

export default component.exports